import { createFileRoute, Outlet, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Skeleton } from '@/components';
import { useAuth } from '@/lib';

function AuthenticatedLayout() {
    const navigate = useNavigate();
    const { isAuthenticated, isLoading } = useAuth();
    useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            navigate({ to: '/login' });
        }
    }, [isAuthenticated, isLoading, navigate]);

    if (isLoading) {
        return (
            <div className="min-h-screen bg-surface flex items-center justify-center">
                <Skeleton className="h-8 w-32" />
            </div>
        );
    }

    if (!isAuthenticated) {
        return null;
    }

    return (
        <div className="min-h-screen bg-surface">
            <Outlet />
        </div>
    );
}

export const Route = createFileRoute('/_authenticated')({
    component: AuthenticatedLayout,
});
